declare var $: any;
import { Component, OnInit, ViewChild, AfterViewInit, TemplateRef, Inject, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  PageFacade,
  UiNotificationService,
  FormValidationsService,
  PageModel,
  Field,
  SquidexDate,
  DataParser,
  SiteSettingFacade,
  ScheduleJob,
  LanguageModel,
  PageContentFacade,
  PageContentModel,
  DynamicSchemaFactory,
  SchemaMetadataFacade,
  DynamicContentSchemaFactory,
  Schema,
  Content,
  LayoutModel,
  TemplateModel,
  DynamicSchemaModel,
  TemplateFacade,
  SchemaPageFacade,
  SchemaPageModel,
  DynamicContentModel,
  DynamicContentSchemaFacade,
  AssetFacade,
  MenuFacade,
  MenuItemFacade,
  AuthenticationService,
  FilterPagination
} from '../../services';
import { SpinnerService } from '../../shared/spinner/spinner.service';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from '../../base/base-component.component';
import { AppToken, Statuses, PreviewDevices, AppSchemaCategory, FieldsName, UserRoles } from '../../models/app-token';
import { FormGroup, FormControl, ValidatorFn, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { DomSanitizer } from '@angular/platform-browser';
import { PageTitleService } from '../../services/general/page-title.service';
import { ESchemaContentStatus } from '../../services/akita/base/enum';
import { guid } from '@datorama/akita';
import { SquidexTool, Validation } from '../../tools';
import { DOCUMENT } from '@angular/common';
import { PageTypeModel } from '../../services/akita/page-type/page-type.model';
import { SchemaPageComponent } from './schema-page/schema-page.component';


const cloneDeep = require('lodash.clonedeep');

@Component({
  selector: 'advanced-page',
  templateUrl: './advanced-page.component.html',
  styleUrls: ['./advanced-page.component.scss']
})
export class AdvancedPageComponent extends BaseComponent implements OnInit, AfterViewInit {


  pageForm: FormGroup;
  pageHiddenFields: string[] = [];
  pagePublishFormGroup: FormGroup;
  pageTemplateForm: FormGroup;


  @ViewChild('propertyTabs', null) propertyTabs: TabsetComponent;
  @ViewChild('contentTabs', null) contentTabs: TabsetComponent;
  @ViewChild("schemaPage", null) schemaPageComponent: SchemaPageComponent;

  modalRef: BsModalRef;
  bsConfig: Partial<BsDatepickerConfig>;

  pageSchema: Schema;
  lastModifiedDate: string;
  title: string;
  id: string;
  draftMode: boolean = false;

  deleted: boolean = false;
  isDraft: boolean = false;
  currentStatus: string;
  scheduledJob: ScheduleJob;
  statusColorClassName: string;
  isAllOpen: boolean;
  isCollapsed: boolean = true;
  collapseControlsEditTemplate: any = {};
  currentPage: PageModel;
  placeHolderPage: PageModel;
  draftVersionExist: boolean = false;

  previewWidth: number;
  previewHeight: number;
  previewUrl: any;
  testUrl: any;

  dataParser: DataParser;
  availableLanguages: LanguageModel[];

  pageContents: PageContentModel[];
  pageContentForm: FormGroup;
  pageContentHiddenFields: string[] = [];
  pageContentFields: Field[];
  schemas: Schema[];
  contents: Content[];

  pageFilters: Content[];
  pageFilterHiddenFields: string[] = [];
  pageFilterForm: FormGroup;
  pageFilterFields: Field[];
  selectedPageFilterId: string;
  pathFields: string[] = [];

  schemaPage: SchemaPageModel;
  relatedContent: DynamicContentModel;
  relatedContentFacade: DynamicContentSchemaFacade;

  pageContentsDescription: any = {};
  selectedPageContentId: string;
  sharedFieldsContentPage: string[] = [];

  userIsOwner: boolean;
  userIsDev: boolean;
  userIsEditor: boolean;
  userIsReadWrite: boolean;
  userIsReader: boolean;

  pageLayouts: LayoutModel[];
  pageTypes: PageTypeModel[];
  pageTemplate: TemplateModel;
  pageTemplateSchema: DynamicSchemaModel;

  thumbnail: string = '';

  cloneNgModel: any = {};
  showAction: boolean = false;

  languageCustomClass: string = 'language-nav-tabs';
  publishDateTime: string = '';

  squidexTool: SquidexTool;
  constructor(
    private readonly pageTitleService: PageTitleService,
    private readonly pageFacade: PageFacade,
    private readonly pageContentFacade: PageContentFacade,
    private readonly schemaPageFacade: SchemaPageFacade,
    private readonly templateFacade: TemplateFacade,
    private readonly menuFacade: MenuFacade,
    private readonly menuItemFacade: MenuItemFacade,
    private readonly siteSettingFacade: SiteSettingFacade,
    private readonly schemaFacadeFactory: DynamicSchemaFactory,
    private readonly schemaMetadataFacade: SchemaMetadataFacade, //To be used
    private readonly contentFacadeFactory: DynamicContentSchemaFactory,
    private readonly uiNotificationService: UiNotificationService,
    private readonly spinnerService: SpinnerService,
    translateService: TranslateService,
    private readonly formValidationService: FormValidationsService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    @Inject(DOCUMENT) private readonly document: any,
    private readonly modalService: BsModalService,
    private readonly sanitizer: DomSanitizer,
    private readonly authenticationService: AuthenticationService,
    private readonly assetFacade: AssetFacade
  ) {
    super(translateService);
    this.setTranslateContext('AdvancedPageComponent');

    this.pageHiddenFields = ['deleted',
      'publishdatetime',
      'deletedatetime',
      'index',
      'thumbnail',
    ];

    this.pageContentHiddenFields = ['deleted',
      'publishdatetime',
      'deletedatetime',
      'pageid',
      'index',
      'ismodified',
      'thumbnail',
    ];  //to be inited by schemaMetatadat hidden Field
    this.pageFilterHiddenFields = ['deleted',
      'publishdatetime',
      'deletedatetime',
      'index',
      'pageid'];  //to be inited by schemaMetatadat hidden Field

    this.sharedFieldsContentPage = [
      'index',
      'metatitle',
      'url',
      'metaKeywords',
      'metaDescription',
      'isactive',
      'issecure',
      'isnoindex',
      'priority',
      'pageName'
    ];

    this.isAllOpen = false;
    this.testUrl = 'https://localhost:5002';
  }

  ngOnInit() {
    this.spinnerService.show();

    this.userIsOwner = this.authenticationService.userHasRole(UserRoles.OWNER);
    this.userIsDev = this.authenticationService.userHasRole(UserRoles.DEVELOPER);
    this.userIsEditor = this.authenticationService.userHasRole(UserRoles.EDITOR);
    this.userIsReadWrite = this.authenticationService.userHasRole(UserRoles.READWRITE);
    this.userIsReader = this.authenticationService.userHasRole(UserRoles.READER);

    this.squidexTool = new SquidexTool();

    //to be removed when siteModel passed in router outlet
    const siteSettingSubscription = this.siteSettingFacade.getSiteLanguages().subscribe(languages => {
      if (languages.length <= 1) {
        this.languageCustomClass = 'hide-nav-tabs';
      }
      this.dataParser = new DataParser(languages);
      this.availableLanguages = languages.sort((a, b) => a.data.index.iv < b.data.index.iv ? -1 : 1);
      const code = this.route.snapshot.paramMap.get('code');
      const name = this.route.snapshot.paramMap.get('name');
      const draftMode = this.route.snapshot.paramMap.get('draftMode') === 'true';

      let isEx = false;
      this.relatedContentFacade = this.contentFacadeFactory.getDynamicContentSchemaFacade(name);
      const relatedContentSubscription = this.relatedContentFacade.getByCode(code, true).subscribe(content => {
        if (content && !isEx) {
          this.relatedContent = content;
          const schemaPageSubscription = this.schemaPageFacade.getSchemaPageByContentId(content.id, true).subscribe(sPage => {
            this.schemaPage = sPage;
            let isExecuted = false;
            const pageSubscription = this.pageFacade.getSchema().subscribe(pageSchema => {
              this.pageSchema = pageSchema;
              const singlePageSubscription = this.pageFacade.get(this.dataParser.pullData(this.schemaPage, FieldsName.PAGE_ID), true).subscribe(page => {
                if (page && !isExecuted) {
                  this.placeHolderPage = page;
                  let clonePage = cloneDeep(page);
                  //mapping propriety of page from content
                  for (let i in this.sharedFieldsContentPage) {
                    const field = this.sharedFieldsContentPage[i];
                    clonePage.data[field] = this.relatedContent.data[field];
                  }
                  this.currentPage = clonePage;
                  if (draftMode) {
                    this.draftMode = draftMode;
                    this.publishDateTime = '';
                    if (this.draftMode && !this.relatedContent.newStatus) {
                      this.createDraft();
                    } else {
                      this.initContentsAndForms();
                    }
                  } else {
                    this.publishDateTime = this.getPublishDate(this.relatedContent);
                    this.draftMode = false;
                    this.initContentsAndForms();
                  }
                  isExecuted = true;
                } else {
                  this.spinnerService.hide();
                  const translateSubscription = this.pageFacade.translate('T').subscribe(c => {
                    this.uiNotificationService.error(c.PAGE_LOAD_ERROR, c.ERROR);
                  });
                  this.subscriptions.push(translateSubscription);
                }
              });
              this.subscriptions.push(singlePageSubscription);
            });
            this.subscriptions.push(pageSubscription);
          });
          this.subscriptions.push(schemaPageSubscription);
          isEx = true;
        } else {
          if (!content) {
            this.templateFacade.translate('T').subscribe(c => {
              this.uiNotificationService.error(c.PAGE_LOAD_ERROR, c.ERROR, 1000);
              this.spinnerService.hide();
            });
          }
        }
      });

      this.subscriptions.push(relatedContentSubscription);

      this.bsConfig = Object.assign({},
        { containerClass: "theme-orange", dateInputFormat: AppToken.ISO_DATES_DATE_TIME_UPDATE });
    });

    this.subscriptions.push(siteSettingSubscription);
  }

  getPublishDate(content: DynamicContentModel) {
    let dt = '';

    if (content.scheduleJob) {
      return this.squidexTool.utcToDateString(content.scheduleJob.dueTime);
    } else {
      return this.squidexTool.utcToDateString(this.dataParser.pullData(content, "publishdatetime"));
    }
  }

  private initContentsAndForms() {
    this.initContents(this.currentPage);
    this.createForm(this.pageSchema.fields, this.currentPage);
    const pageUrl = this.buildUrl(this.dataParser.pullData(this.currentPage, 'url', this.dataParser.currentLanguageCode));
    this.setPreviewUrl(pageUrl);
  }

  private initContents(pageContent: PageModel) {
    this.lastModifiedDate = this.pageFacade.getLastModifiedDate(pageContent);
    this.title = this.dataParser.pullData(pageContent, FieldsName.METATITLE, this.dataParser.currentLanguageCode);
    this.id = pageContent.id;
    if (this.relatedContent.scheduleJob && this.relatedContent.scheduleJob.status === 'Published') {
      this.currentStatus = this.relatedContent.scheduleJob.status;
    } else if (this.relatedContent.newStatus) {
      this.currentStatus = this.relatedContent.newStatus;
    } else {
      this.currentStatus = this.relatedContent.status;
    }
    this.scheduledJob = this.relatedContent.scheduleJob;
    this.deleted = this.dataParser.pullData(pageContent, FieldsName.DELETED, 'iv');
    this.updateStatusAndStatusColor(this.currentStatus);
    const pageUrl = `${this.document.location.origin}${this.dataParser.pullData(this.relatedContent, 'url', this.dataParser.currentLanguageCode)}?draftMode=${this.draftMode}`;
    this.testUrl = pageUrl;

    this.updateIframeSrc(this.testUrl, PreviewDevices.DESKTOP.name);

    let manageContent: HTMLElement = document.getElementById('manage_content') as HTMLElement;
    manageContent.click();

    //check if draft version exist
    this.isExistDraftVersion();

    this.tc().subscribe(v => {
      let title = '';
      if (this.title && this.title !== '') {
        title = v['NAME'] + this.title;
      }
      this.pageTitleService.setTitle(title);
      this.pageTitleService.key = 'ADVANCEDPAGE.NAME';
    });

    this.pageContentFacade.getPageContentsByPageId(this.id, 'data/index/iv', this.draftMode).subscribe(pageContents => {
      this.pageContents = pageContents;
    });

    //init all schema
    this.schemaFacadeFactory.getSchemasMetadataByCategory(AppSchemaCategory.CONTENT_SCHEMAS).subscribe(schemas => {
      this.schemas = schemas.filter(sch => sch.name.length <= AppToken.SCHEMA_NAME_MAX_LEGTH);
    });

    //init pageLayouys
    this.contentFacadeFactory.getDynamicContentSchemaFacade(AppToken.LAYOUT_SCHEMA_NAME)
      .getTopX(1000, undefined, undefined, ESchemaContentStatus.Published).subscribe(layouts => {
        this.pageLayouts = layouts;
      });

    //init pageTypes
    this.contentFacadeFactory.getDynamicContentSchemaFacade(AppToken.PAGE_TYPE_SCHEMA_NAME)
      .getTopX(1000, undefined, undefined, ESchemaContentStatus.Published).subscribe(pageTypes => {
        this.pageTypes = pageTypes;
      });


    this.contentFacadeFactory.getDynamicContentSchemaFacade(AppToken.PAGE_FILTER_SCHEMA_NAME)
      .getByParentId(this.id, FieldsName.PAGE_ID, 'id', this.draftMode).subscribe(pageFilters => {
        this.pageFilters = pageFilters;

        this.pageFilters.forEach(pageFilter => {
          const data: any = {
            isCollapsed: true,
          };
          this.collapseControlsEditTemplate[pageFilter.id] = data;
        });

      });

    //init template
    const templateId = this.dataParser.pullData(pageContent, FieldsName.TEMPLATE)[0];
    if (Validation.isValidGuid(templateId)) {

      this.templateFacade.get(templateId, this.draftMode).subscribe(template => {
        this.pageTemplate = template;
        if (this.pageTemplate) {
          this.schemaFacadeFactory.getDynamicSchemaFacade(AppToken.TEMPLATE_SCHEMA_NAME).getSchemaDefinition()
            .subscribe(templateSchema => {
              this.pageTemplateSchema = templateSchema;
              this.pageTemplateForm = new FormGroup(this.generateFormGroup(null, templateSchema.fields, [''], this.pageTemplate, this.draftMode));
            });
        }
      });
    } else {
      this.pageTemplate = null;
      this.pageTemplateForm = null;
      this.pageTemplateSchema = null;
    }
  }
  private isDirty() {
    return (this.pageForm || this.pageTemplateForm);
  }

  private updatePageTemplateContent(hideSpinner: boolean = true) {
    let tempTemplatePage = cloneDeep(this.pageTemplate);
    if (this.isDirty()) {
      const newData = this.dataParser.setContent(tempTemplatePage, this.pageTemplateSchema.fields.find(f => f.name === FieldsName.BODY) as Field, this.pageTemplateForm.get(FieldsName.BODY).value);
      this.templateFacade.update(tempTemplatePage.id, newData)
        .subscribe(v => {
          if (v) {
            this.lastModifiedDate = this.pageFacade.getLastModifiedDate(v);
            if (hideSpinner) {
              this.templateFacade.translate('T').subscribe(c => {
                this.uiNotificationService.success(c.UPDATE_PAGE_SUCCESS, c.SUCCESS_TITLE);
                this.spinnerService.hide();
              });
            }
          }
        });
    }
  }

  toogleShowAction() {
    this.showAction = !this.showAction;
  }

  openCloneModal(cloneTemplate) {
    console.log(cloneTemplate);
    this.modalRef = this.modalService.show(cloneTemplate);
  }

  confirmClone() {
    let name = this.cloneNgModel['name'];

    if (Validation.isNullEmptyOrWhiteSpaces(name)) {
      this.uiNotificationService.error('Name is required', 'Error');
      return;
    }

    let urls = {};

    this.availableLanguages.forEach(lang => {
      let langCode = lang.data.code.iv;
      let url = this.cloneNgModel[`url_${langCode}`];

      if (Validation.isNullEmptyOrWhiteSpaces(url)) {
        this.uiNotificationService.error(`Url ${langCode} is required`, 'Error');
        return;
      }

      urls[langCode] = url;
    });

    //TODO: validate urls are unique and begin with /
    this.pageInternalService.clonePage(this.currentPage.id, name, urls, true).subscribe(callback => {
      this.modalRef.hide();
      this.pageSelected = null;
      if (callback.isSuccess()) {
        console.log(callback.content);
        this.router.navigateByUrl(`/page/${callback.content.data.code.iv}`)
        return;
      }

      this.uiNotificationService.error(callback.getMessage(), 'Error');
    });
  }

  createDraft() {
    this.pageFacade.createDraft(this.currentPage.id).subscribe(p => {

      this.pageFacade.removeStore(p.id);

      //create draft for page content
      this.relatedContentFacade.createDraft(this.relatedContent.id).subscribe(c => {
        this.currentPage = p;
        this.relatedContent = c;
        this.initContentsAndForms();

        //create draft for template
        this.templateFacade.createDraft(this.pageTemplate.id).subscribe();

        //create draft for page section
        this.pageContents.forEach(pc => {
          this.pageContentFacade.createDraft(pc.id).subscribe();
        });

        //create draft for page filter
        this.pageFilters.forEach(pf => {
          this.contentFacadeFactory.getDynamicContentSchemaFacade(AppToken.PAGE_FILTER_SCHEMA_NAME).createDraft(pf.id).subscribe();
        });
        this.spinnerService.hide();
      });
    });
  }

  deleteDraft() {
    this.pageFacade.removeDraft(this.currentPage.id).subscribe(() => {
      this.relatedContentFacade.removeDraft(this.relatedContent.id).subscribe(c => {
        this.isExistDraftVersion();
        this.pageFacade.translate('T').subscribe(c => {
          this.uiNotificationService.success(c.DELETE_SUCCESS, c.SUCCESS_TITLE);
          this.reloadPage(false);
        });
      });
    });

    this.templateFacade.removeDraft(this.pageTemplate.id).subscribe();

    this.pageContents.forEach(pc => {
      this.pageContentFacade.removeDraft(pc.id).subscribe();
    });

    this.pageFilters.forEach(pf => {
      this.contentFacadeFactory.getDynamicContentSchemaFacade(AppToken.PAGE_FILTER_SCHEMA_NAME).removeDraft(pf.id).subscribe();
    });
  }

  private isExistDraftVersion() {
    if (!this.relatedContent.newStatus && this.relatedContent.status === 'Draft' && !this.relatedContent.scheduleJob) {
      this.draftVersionExist = true;
      this.draftMode = true;
      this.publishDateTime = '';
    } else {
      if (this.relatedContent.scheduleJob) {
        this.currentStatus = "Published"
      } else {
        this.relatedContentFacade.get(this.relatedContent.id, true).subscribe(p => {
          if (p.newStatus) {
            this.draftVersionExist = true;
            this.draftMode = true;
            this.publishDateTime = '';
          } else {
            this.draftVersionExist = false;
          }
        });
      }
    }
  }

  updateRelatedContent(updateChild = false) {
    if (!this.pageForm.valid) {
      this.pageForm.markAllAsTouched();
      console.error("Form is not valid");
      console.error(this.pageForm);
      this.pageFacade.translate('T').subscribe(c => {
        this.uiNotificationService.error(c.INVALID_FORM, c.FAILED_TITLE, 10000);
      });
      return;
    }

    const values = this.pageForm.value;

    let newContentData: any = {};
    newContentData = cloneDeep(this.relatedContent.data);

    let sharedFields = this.pageSchema.fields.filter(field => this.sharedFieldsContentPage.includes(field.name));

    for (let field of sharedFields) {
      if (field.partitioning === 'language') {
        for (const language of this.availableLanguages.map(languages => languages.data.code.iv)) {
          newContentData = this.dataParser.setData(newContentData, field, values[field.name + '_' + language], language);
        }
      } else {
        newContentData = this.dataParser.setData(newContentData, field, values[field.name]);
      }
    }

    const urls = new Array();
    for (const language of this.availableLanguages.map(languages => languages.data.code.iv)) {
      urls.push(newContentData['url'][language]);
    }

    const urlsDistinct = [...new Set(urls)];
    if (urls.length > urlsDistinct.length) {
      this.pageFacade.translate('T').subscribe(c => {
        this.uiNotificationService.error(c.URL_NOT_DISTINCT, c.FAILED_TITLE, 10000);
      });
      return;
    }
    let startWithSlash: boolean = true;
    urls.forEach(url => {
      if (!url.trim().startsWith('/')) {
        startWithSlash = false;
        return;
      }
    });

    if (!startWithSlash) {
      this.pageFacade.translate('T').subscribe(c => {
        this.uiNotificationService.error(c.URL_START_SLASH, c.FAILED_TITLE, 10000);
      });
      return false;
    }

    const allVersionParm = new FilterPagination();
    allVersionParm.from = 0;
    allVersionParm.to = 1;
    allVersionParm.filter = '';
    allVersionParm.orderBy = 'lastModified descending';

    let filterList: object[] = new Array();
    for (const lg of this.availableLanguages.map(languages => languages.data.code.iv)) {

      for (const language of this.availableLanguages.map(languages => languages.data.code.iv)) {
        let data: any = {};
        data = {
          path: `data.url.${lg}`,
          op: 'eq',
          value: newContentData['url'][language]
        };

        filterList.push(data);
      }
    }

    let orFilter: any = {};
    orFilter = {
      or: filterList
    }

    this.pageFacade.validateUrl(allVersionParm, ESchemaContentStatus.All, orFilter, this.currentPage).subscribe(total => {
      if (total > 0) {
        this.pageFacade.translate('T').subscribe(c => {
          this.uiNotificationService.error(c.URL_TAKEN, c.FAILED_TITLE, 10000);
        });
        return;
      }

      this.spinnerService.show();

      if (this.relatedContent) {
        this.relatedContentFacade
          .update(this.relatedContent.id, newContentData)
          .subscribe(content => {
            this.lastModifiedDate = this.pageFacade.getLastModifiedDate(content);
            this.relatedContent = content;
          });
      }

      newContentData = {};
      newContentData = cloneDeep(this.placeHolderPage.data);
      let pageFields = this.pageSchema.fields
        .filter(field => !this.pageHiddenFields.includes(field.name))
        .filter(field => !this.sharedFieldsContentPage.includes(field.name))

      for (let field of pageFields) {
        if (field.partitioning === 'language') {
          for (const language of this.availableLanguages.map(languages => languages.data.code.iv)) {
            newContentData = this.dataParser.setData(newContentData, field, values[field.name + '_' + language], language);
          }
        } else {
          newContentData = this.dataParser.setData(newContentData, field, values[field.name]);
        }
      }

      this.pageFacade
        .update(this.id, newContentData)
        .subscribe(newContent => {
          if (newContent.data.code.iv !== '' && newContent.data.url[this.dataParser.currentLanguageCode] !== '' && this.pageTemplateForm.dirty && !newContent.data.issecure.iv) {
            this.updatePageTemplateContent(false);
            this.pageCapture(newContent);
          } else {
            this.updatePageTemplateContent();
            if (updateChild) {
              this.schemaPageComponent.updateChild(false);
            }
          }
        },
          err => {
            console.error('Observer got an error: ' + err);
            this.spinnerService.hide();
          }
        );

      // this.spinnerService.hide();
    });
  }

  switchModeDratLive(event) {
    this.draftMode = event.srcElement.checked;

    this.pageFacade.get(this.currentPage.id, this.draftMode).subscribe(page => {
      this.relatedContentFacade.get(this.relatedContent.id, this.draftMode).subscribe(content => {
        this.relatedContent = content;
        let clonePage = cloneDeep(page);
        //mapping propriety of page from content
        for (let i in this.sharedFieldsContentPage) {
          let field = this.sharedFieldsContentPage[i];
          clonePage.data[field] = content.data[field];
        }
        this.currentPage = clonePage;
        if (this.draftMode) {
          if (this.draftMode && !this.relatedContent.newStatus) {
            this.createDraft();
          } else {
            this.initContentsAndForms();
          }
        } else {
          this.draftMode = false;
          this.initContentsAndForms();
        }
      });
    });
  }

  reloadPage(draftMode: boolean) {
    this.draftMode = draftMode;

    this.pageFacade.get(this.currentPage.id, this.draftMode).subscribe(page => {
      this.spinnerService.show();
      this.relatedContentFacade.get(this.relatedContent.id, this.draftMode).subscribe(content => {
        this.relatedContent = content;
        let clonePage = cloneDeep(page);
        //mapping propriety of page from content
        for (let i in this.sharedFieldsContentPage) {
          let field = this.sharedFieldsContentPage[i];
          clonePage.data[field] = content.data[field];
        }
        this.currentPage = clonePage;
        if (this.draftMode) {
          if (this.draftMode) {
            this.createDraft();
          } else {
            this.initContentsAndForms();
          }
        } else {
          this.draftMode = false;
          this.initContentsAndForms();
        }
      });
    });
  }

  private createForm(schemaFields: Field[], pageContent: PageModel): void {

    let tempPageContent = cloneDeep(pageContent);

    const formGroup: any = {};

    for (let i = 0; i < schemaFields.length; i++) {

      const field = schemaFields[i];

      const fieldProperties = field.properties;

      if (field.partitioning === 'language') {

        for (const language of this.availableLanguages.map(languages => languages.data.code.iv)) {
          const fieldName = `${field.name}_${language}`;

          const fieldValue = this.dataParser.getData(tempPageContent, field, language);

          const control = new FormControl(fieldValue);

          const isRequired = fieldProperties.isRequired;

          let validators: ValidatorFn[] = [];

          if (isRequired) {
            validators.push(Validators.required);
          }

          if (fieldProperties.maxLength) {
            let maxLengthValidator = Validators.maxLength(fieldProperties.maxLength);
            validators.push(maxLengthValidator);
          }

          if (fieldProperties.minLength) {
            let minLengthValidator = Validators.minLength(fieldProperties.minLength);
            validators.push(minLengthValidator);
          }

          //custom pattern
          if (fieldProperties.pattern) {
            validators = validators.concat(this.formValidationService.getValidators(control, fieldProperties.pattern));
          }

          control.setValidators(validators);

          formGroup[fieldName] = control;
        }
      } else {

        const fieldValue = this.dataParser.getData(tempPageContent, field, 'iv');

        const control = new FormControl(fieldValue);

        const isRequired = fieldProperties.isRequired;

        let validators: ValidatorFn[] = [];

        if (isRequired) {
          validators.push(Validators.required);
        }

        if (fieldProperties.maxLength) {
          let maxLengthValidator = Validators.maxLength(fieldProperties.maxLength);
          validators.push(maxLengthValidator);
        }

        if (fieldProperties.minLength) {
          let minLengthValidator = Validators.minLength(fieldProperties.minLength);
          validators.push(minLengthValidator);
        }

        //custom pattern
        if (fieldProperties.pattern) {
          validators = validators.concat(this.formValidationService.getValidators(control, fieldProperties.pattern));
        }

        control.setValidators(validators);

        formGroup[field.name] = control;
      }

    }
    //end loop
    this.pageForm = new FormGroup(formGroup);

    if (this.relatedContent) {
      this.createMetaDataFormGroup(this.relatedContent);
    }
    this.pageForm.addControl('pagePublishFormGroup', this.pagePublishFormGroup);

    this.spinnerService.hide();

  }

  private createGenericFormControl(field: string, content: any): FormControl {

    const fieldValue = content[field];

    const control = new FormControl(fieldValue);

    //let validators: ValidatorFn[] = [];

    //control.setValidators(validators);

    return control;
  }

  private createMetaDataFormGroup(pageContent: PageModel): void {

    let tempPageContent: PageModel = cloneDeep(pageContent);

    const fields = Object.keys(tempPageContent);

    let metaDataFormGroup: any = {};
    let scheduledJob = false;

    for (let i = 0; i < fields.length; i++) {
      const field = fields[i];
      // this.publishDateTime = this.dataParser.pullData(tempPageContent, "publishdatetime");

      if (field === 'scheduleJob') {
        scheduledJob = true;

        let fieldsValue = tempPageContent.scheduleJob;

        if (!fieldsValue) {
          fieldsValue = { id: null, dueTime: null, scheduledBy: null, status: null };
          if (this.publishDateTime && this.getPageStatus(tempPageContent) === 'Published') {
            fieldsValue.dueTime = this.squidexTool.dateStringToUtc(this.publishDateTime);
          }

        } else {
          fieldsValue.dueTime = this.squidexTool.dateStringToUtc(this.publishDateTime);
        }

        const fs = Object.keys(fieldsValue);

        let scheduleJobFromGroup: any = {};

        for (let i = 0; i < fs.length; i++) {
          scheduleJobFromGroup[fs[i]] = this.createGenericFormControl(fs[i], fieldsValue);
        }

        metaDataFormGroup[field] = new FormGroup(scheduleJobFromGroup);
      } else {
        metaDataFormGroup[field] = this.createGenericFormControl(fields[i], tempPageContent);
      }
    }

    if (!scheduledJob) {
      let fieldsValue = { id: null, dueTime: null, scheduledBy: null, status: null };

      this.publishDateTime = this.getPublishDate(tempPageContent);

      if (tempPageContent.newStatus) {
        fieldsValue.status = tempPageContent.newStatus;
        this.currentStatus = tempPageContent.newStatus;
        this.draftMode = true;

      } else {
        const dt = this.dataParser.pullData(tempPageContent, 'publishdatetime')
        if (this.publishDateTime > '1970-01-01') {
          fieldsValue.dueTime = this.publishDateTime;
        }
        fieldsValue.status = tempPageContent.status;
        this.currentStatus = tempPageContent.status;
        this.draftMode = false;
      }

      const fs = Object.keys(fieldsValue);
      const scheduleJobFromGroup: any = {};

      for (let i = 0; i < fs.length; i++) {
        scheduleJobFromGroup[fs[i]] = this.createGenericFormControl(fs[i], fieldsValue);
      }
      metaDataFormGroup['scheduleJob'] = new FormGroup(scheduleJobFromGroup);
    }

    this.pagePublishFormGroup = new FormGroup(metaDataFormGroup);
  }

  getPageStatus(page?: PageModel) {
    if (!page) {
      page = this.currentPage;
    }

    if (page.newStatus && page.newStatus === 'Draft')
      return 'Draft';
    else if (page.status === 'Draft')
      return 'Draft';
    else
      return 'Published';
  }

  publish() {
    let publishStatus = Statuses.PUBLISHED.name;
    if (publishStatus === this.currentStatus) {
      this.notify(this.currentStatus, false);
      return false;
    }

    switch (publishStatus) {
      case Statuses.PUBLISHED.name:
        this.spinnerService.show();
        let dueTime = this.pageForm.value.pagePublishFormGroup.scheduleJob.dueTime;
        let publishDate: string;
        if (!dueTime) {
          dueTime = null;
          publishDate = null;
        } else {
          const currentDate = new Date(Date.now());
          const dt = this.pageForm.value.pagePublishFormGroup.scheduleJob.dueTime;
          let dueTimeDate = new SquidexDate(dt);
          if (dueTimeDate < currentDate) {
            publishDate = null
          } else {
            publishDate = new SquidexDate(dueTimeDate).formatUtc();
          }
        }
        this.relatedContentFacade.updateStatus(this.relatedContent.id, publishStatus, publishDate)
          .subscribe(content => {
            let tempContent = cloneDeep(content);
            if (content.scheduleJob && content.scheduleJob.status === 'Published') {
              this.currentStatus = content.scheduleJob.status
            }
            this.relatedContent = tempContent;
            if (this.relatedContent.newStatus) {
              this.currentStatus = this.relatedContent.newStatus;
            } else {
              this.currentStatus = this.relatedContent.status;
            }
            this.draftMode = false;
            this.draftVersionExist = false;
            this.lastModifiedDate = this.pageFacade.getLastModifiedDate(content);
            this.scheduledJob = content.scheduleJob;

            if (!publishDate) {
              let dt = new Date();
              publishDate = new SquidexDate(dt).formatUtc();
            }

            this.dataParser.putData(tempContent.data, "publishdatetime", publishDate);
            this.publishMode = true;
            this.publishDateTime = this.squidexTool.utcToDateString(publishDate);

            this.currentPage = tempContent;
            this.relatedContentFacade.getSchema().subscribe(schema => {
              const publishDateField = schema.fields.find(f => f.name === FieldsName.PUBLISH_DATE_TIME);
              this.relatedContentFacade.update(this.relatedContent.id, tempContent.data).subscribe(r => {
                this.initContentsAndForms();
                this.updateStatusAndStatusColor(content.status);
                this.spinnerService.hide();
              });
            });

            this.notify(this.currentStatus);
          });

        //publish template
        this.templateFacade.updateStatus(this.pageTemplate.id, publishStatus, dueTime).subscribe();

        //publish page section
        this.pageContents.forEach(pc => {
          this.pageContentFacade.updateStatus(pc.id, publishStatus, dueTime).subscribe();
        });

        //publish page filter
        this.pageFilters.forEach(pf => {
          this.contentFacadeFactory.getDynamicContentSchemaFacade(AppToken.PAGE_FILTER_SCHEMA_NAME).updateStatus(pf.id, publishStatus, dueTime).subscribe();
        });

        break;
      case Statuses.DRAFT.name:
        this.relatedContentFacade.updateStatus(this.relatedContent.id, this.pageForm.value.pagePublishFormGroup.status, null)
          .subscribe(content => {
            this.relatedContent = content;
            if (this.relatedContent.newStatus) {
              this.currentStatus = this.relatedContent.newStatus;
            } else {
              this.currentStatus = this.relatedContent.status;
            }
            this.scheduledJob = content.scheduleJob;
            this.updateStatusAndStatusColor(content.status);
            this.notify(this.currentStatus);
          });
        break;
    }

    return false;
  }

  private notify(status: string, isSuccess: boolean = true): void {
    if (isSuccess) {
      this.pageFacade.translate('T.STATUS_UPDATE_PAGE', { currentStatus: status }).subscribe(msg => {
        this.pageFacade.translate('T').subscribe(c => {
          this.uiNotificationService.success(msg, c.SUCCESS_TITLE, 10000);
        });
      });
    } else {
      this.pageFacade.translate('T.STATUS_ERROR', { currentStatus: status }).subscribe(msg => {
        this.pageFacade.translate('T').subscribe(c => {
          this.uiNotificationService.error(msg, c.FAILED_TITLE, 10000);
        });
      });
    }
  }

  private updateStatusAndStatusColor(status: string) {
    switch (status) {
      case Statuses.PUBLISHED.name:
        this.isDraft = false;
        this.statusColorClassName = 'badge green-badge';
        break;
      case Statuses.DRAFT.name:
        this.isDraft = true;
        this.statusColorClassName = 'badge draft-badge';
        break;
      default:
        this.statusColorClassName = 'badge red-badge';
    }
  }

  private updateStatusSelect(e) {
    this.updateStatusAndStatusColor(e.target.value);
  }

  private closeModal() {
    this.selectedPageContentId = null;
    this.collapseAllEditForm();
    if (this.modalRef) {
      this.modalRef.hide();
    }
  }

  openModalDeletePage(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  private confirmDeleteDrafts() {
    const subscription = this.pageFacade.translate('T').subscribe(c => {
      this.deleteDraft();
    });
    this.closeModal();
    this.subscriptions.push(subscription);
  }

  private confirmDeletePage() {
    const subscription = this.pageFacade.translate('T').subscribe(c => {

      if (Validation.isValidGuid(this.id)) {

        //remove all section relation from page
        this.pageContentFacade.getPageContentsByPageId(this.id).subscribe(pageContents =>
          pageContents.forEach(pageContent => {
            this.pageContentFacade.remove(pageContent.id).subscribe();
          })
        );

        //remove all content relation from page
        const schemaPageFacade = this.contentFacadeFactory.getDynamicContentSchemaFacade(AppToken.SCHEMA_PAGE_SCHEMA_NAME);
        schemaPageFacade.getByParentId(this.id, FieldsName.PAGE_ID, FieldsName.ID, true).subscribe(schemaPages => {
          schemaPages.forEach(sPage => {
            schemaPageFacade.remove(sPage.id).subscribe();
          });
        });

        //remove all page filter
        const pageFilterFacade = this.contentFacadeFactory.getDynamicContentSchemaFacade(AppToken.PAGE_FILTER_SCHEMA_NAME);
        schemaPageFacade.getByParentId(this.id, FieldsName.PAGE_ID, FieldsName.ID, true).subscribe(pageFilter => {
          pageFilter.forEach(pFilter => {
            pageFilterFacade.remove(pFilter.id).subscribe();
          });
        });

        //remove template related to page
        this.templateFacade.remove(this.pageTemplate.id).subscribe();

        //remove menuItem from menu then remove it
        this.menuItemFacade.getMenuItemsByPageId(this.id).subscribe(menuItems => {
          menuItems.forEach(menuItem => {
            let isExcuted = false;
            this.menuFacade.getByParentId(menuItem.id, FieldsName.MENU_ITEMS, FieldsName.ID, true).subscribe(menus => {
              if (!isExcuted) {
                menus.forEach(menu => {
                  let menuData = this.clone(menu.data);
                  let menuItems = menuData.menuItems.iv as string[];
                  const index = menuItems.indexOf(menuItem.id);
                  if (index !== -1) {
                    menuItems.splice(index, 1);
                  }
                  this.dataParser.putData(menuData, FieldsName.MENU_ITEMS, menuItems);
                  this.menuFacade.update(menu.id, menuData).subscribe();
                  isExcuted = true;
                });
              }
            });
            this.menuItemFacade.remove(menuItem.id).subscribe();
          });
        });

        //remove this page
        this.pageFacade.remove(this.id).toPromise().then(
          content => {
            this.deleted = this.dataParser.pullData(content, FieldsName.DELETED, 'iv');
            this.uiNotificationService.success(c.DELETE_SUCCESS, c.SUCCESS_TITLE);
            this.spinnerService.show();
            setTimeout(() => {
              this.router.navigateByUrl('/pages');
            }
              , 5000);
          },
          () => {
            this.uiNotificationService.success(c.DELETE_FAILED, c.FAILED_TITLE);
            this.closeModal();
          });

      }
    });
    this.subscriptions.push(subscription);
  }

  openModalDeletePageContent(template: TemplateRef<any>, id: string) {
    this.selectedPageContentId = id;
    this.modalRef = this.modalService.show(template);
  }

  private confirmDeletePageContent() {
    const subscription = this.pageContentFacade.translate('T').subscribe(c => {
      if (Validation.isValidGuid(this.selectedPageContentId)) {
        this.pageContentFacade.remove(this.selectedPageContentId).toPromise().then(
          () => {
            this.uiNotificationService.success(c.DELETE_SUCCESS, c.SUCCESS_TITLE);
            this.pageContentFacade.getPageContentsByPageId(this.id, 'id', this.draftMode).subscribe(pageContents => {
              this.pageContents = pageContents;
            });
          },
          () => { this.uiNotificationService.success(c.DELETE_FAILED, c.FAILED_TITLE); });
      }
    });

    this.closeModal();
    this.subscriptions.push(subscription);
  }

  openModalDeletePageFilter(template: TemplateRef<any>, id: string) {
    this.selectedPageFilterId = id;
    this.modalRef = this.modalService.show(template);
  }

  private confirmDeletePageFilter() {
    const subscription = this.pageContentFacade.translate('T').subscribe(c => {
      if (Validation.isValidGuid(this.selectedPageFilterId)) {
        this.contentFacadeFactory.getDynamicContentSchemaFacade(AppToken.PAGE_FILTER_SCHEMA_NAME).remove(this.selectedPageFilterId).toPromise().then(
          () => {
            this.uiNotificationService.success(c.DELETE_SUCCESS, c.SUCCESS_TITLE);
            this.pageFilters = this.pageFilters.filter(pf => pf.id !== this.selectedPageFilterId);
            this.selectedPageFilterId = null;
          },
          () => { this.uiNotificationService.success(c.DELETE_FAILED, c.FAILED_TITLE); });
      }
    });
    this.closeModal();
    this.subscriptions.push(subscription);
  }

  toggleDescription(e) {
    $(e.currentTarget).closest('.frais-main').find('.minu-cnt').slideToggle();
    $(e.currentTarget).closest('.frais-main').toggleClass('active');
  }

  private buildUrl(url: string): string {
    if (!url) {
      throw ("Url undefined");
    }
    return `${this.document.location.origin}${url}?draftMode=${this.draftMode}`;
  }

  selectTab(e, tabId: number, tabSet: TabsetComponent) {

    if (tabSet === this.contentTabs && tabId === 0) {
      const pageUrl = this.buildUrl(this.dataParser.pullData(this.relatedContent, 'url', this.dataParser.currentLanguageCode));
      this.updateIframeSrc(pageUrl);
    }
    tabSet.tabs[tabId].active = true;
    $(e.currentTarget).parent().parent().find('li').removeClass('active');
    $(e.currentTarget).parent().addClass('active');
  }

  changeLanguage(event, languageCode) {
    this.dataParser.changeLanguage(languageCode);
    $(event.currentTarget).parent().parent().find('li').removeClass('active');
    $(event.currentTarget).parent().addClass('active');
    const pageUrl = `${this.document.location.origin}${this.dataParser.pullData(this.relatedContent, 'url', this.dataParser.currentLanguageCode)}?draftMode=${this.draftMode}`;
    this.updateIframeSrc(pageUrl, '');
    this.setPreviewUrl(pageUrl);
  }

  private updateIframe(event, url: string, plateForme: string) {
    this.updateIframeSrc(url, plateForme);
    $(event.currentTarget).parent().parent().find('li').removeClass('active');
    $(event.currentTarget).parent().addClass('active');
  }

  private updateIframeSrc(url: string, plateForme: string = null) {
    switch (plateForme) {
      case PreviewDevices.DESKTOP.name:
        this.previewHeight = PreviewDevices.DESKTOP.height;
        this.previewWidth = PreviewDevices.DESKTOP.width;
        break;
      case PreviewDevices.TABLET.name:
        this.previewHeight = PreviewDevices.TABLET.height;
        this.previewWidth = PreviewDevices.TABLET.width;
        break;
      case PreviewDevices.PHONE.name:
        this.previewHeight = PreviewDevices.PHONE.height;
        this.previewWidth = PreviewDevices.PHONE.width;
        break;
      default:
    }

    this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  private getLocalizableFieldName(fieldName: string, languageCode): string {
    return `${fieldName}_${languageCode}`;
  }

  openModalCreatePageContent(template: TemplateRef<any>) {
    this.pageContentFacade.getSchema().subscribe(pageContentSchema => {
      this.pageContentFields =
        pageContentSchema.fields.filter(field => !this.pageContentHiddenFields.includes(field.name));
      this.pageContentForm = new FormGroup(this.generateFormGroup(this.pageContentFacade,
        pageContentSchema.fields,
        this.pageContentHiddenFields));

      this.modalRef = this.modalService.show(template);
    });
  }

  openModalCreatePageFilter(template: TemplateRef<any>, pageFilterId: string) {
    this.selectedPageFilterId = pageFilterId;
    this.contentFacadeFactory.getDynamicContentSchemaFacade(AppToken.PAGE_FILTER_SCHEMA_NAME).getSchema().subscribe(
      pageFilterSchema => {
        this.pageFilterFields =
          pageFilterSchema.fields.filter(field => !this.pageFilterHiddenFields.includes(field.name));
        let pageFilterContent = null;
        if (Validation.isValidGuid(this.selectedPageFilterId)) {
          this.collapseAllEditForm();
          pageFilterContent = this.pageFilters.find(pf => pf.id === pageFilterId);
          this.getPathFilterFromSchemaName(this.dataParser.pullData(pageFilterContent, FieldsName.CONTENT_TYPE));
          this.collapseControlsEditTemplate[this.selectedPageFilterId]['isCollapsed'] =
            !this.collapseControlsEditTemplate[this.selectedPageFilterId]['isCollapsed'];
        } else {
          this.collapseAllEditForm();
          this.isCollapsed = !this.isCollapsed;
        }
        this.pageFilterForm = new FormGroup(
          this.generateFormGroup(
            this.contentFacadeFactory.getDynamicContentSchemaFacade(AppToken.PAGE_FILTER_SCHEMA_NAME),
            pageFilterSchema.fields,
            this.pageFilterHiddenFields,
            pageFilterContent));
      });
  }

  private collapseAllEditForm() {
    const desc = this.collapseControlsEditTemplate;
    Object.keys(desc).forEach(function (key) {
      if (desc) {
        desc[key]['isCollapsed'] = true;
      }
    });
    this.collapseControlsEditTemplate = desc;
    this.isCollapsed = true;
    const container = document.querySelectorAll('.last_modify-inner');
    container.forEach(item => {
      item.classList.remove('bubble-content-context');
    });
  }

  private updateContentsSelect(e) {
    this.contentFacadeFactory.getDynamicContentSchemaFacade(e.target.value)
      .getTopX(1000, undefined, undefined, ESchemaContentStatus.Published).subscribe(contents => {
        this.contents = contents;
        this.pageContentForm.get('contentid').reset();
      });
  }

  private updatePathFilterSelect(e) {
    this.getPathFilterFromSchemaName(e.target.value);
  }

  private getPathFilterFromSchemaName(schemaName: string) {
    this.contentFacadeFactory.getDynamicContentSchemaFacade(schemaName)
      .getSchema().subscribe(contentSchema => {
        this.pathFields = [];
        for (let i = 0; i < contentSchema.fields.length; i++) {
          const field = contentSchema.fields[i];
          if (field.partitioning === 'language') {
            for (const language of this.availableLanguages.map(languages => languages.data.code.iv)) {
              let val = 'data';
              val += '.' + field.name + '.' + language;
              this.pathFields.push(val);
            }
          } else {
            let val = 'data';
            val += '.' + field.name + '.iv';
            this.pathFields.push(val);
          }
        }
      });
  }

  private createPageFilter() {

    if (!this.pageFilterForm.dirty) {
      this.pageContentFacade.translate('T').subscribe(c => {
        this.uiNotificationService.error(c.CREATE_FAILED, c.FAILED_TITLE);
        this.pageFilterForm.markAllAsTouched();
      });
      return;
    }

    const values = this.pageFilterForm.value;

    let newPageFilterData: any = {};

    for (let field of this.pageFilterFields) {
      if (field.partitioning === 'language') {
        for (const language of this.availableLanguages.map(languages => languages.data.code.iv)) {
          newPageFilterData = this.dataParser.setData(newPageFilterData, field, values[this.getLocalizableFieldName(field.name, language)], language);
        }
      } else {
        newPageFilterData = this.dataParser.setData(newPageFilterData, field, values[field.name]);
      }
    }

    const ids: string[] = [];
    ids.push(this.id);

    newPageFilterData = this.dataParser.putData(newPageFilterData, FieldsName.PAGE_ID, ids);
    newPageFilterData = this.dataParser.putData(newPageFilterData, FieldsName.INDEX, 0);

    if (Validation.isValidGuid(this.selectedPageFilterId)) {
      this.contentFacadeFactory.getDynamicContentSchemaFacade(AppToken.PAGE_FILTER_SCHEMA_NAME)
        .update(this.selectedPageFilterId, newPageFilterData).subscribe(pf => {
          this.pageFilters = this.pageFilters.filter(pf => pf.id !== this.selectedPageFilterId);
          this.pageFilters.push(pf);
          this.pageContentFacade.translate('T').subscribe(c => {
            this.uiNotificationService.success(c.UPDATE_SUCCESS, c.SUCCESS_TITLE);
            this.selectedPageFilterId = null;
            this.closeModal();
          });
        });
    } else {
      newPageFilterData = this.dataParser.putData(newPageFilterData, FieldsName.CODE, guid());
      this.contentFacadeFactory.getDynamicContentSchemaFacade(AppToken.PAGE_FILTER_SCHEMA_NAME).createAsPublished(newPageFilterData).subscribe(pf => {
        this.pageFilters.push(pf);
        const data: any = {
          isCollapsed: true,
        };
        this.collapseControlsEditTemplate[pf.id] = data;
        this.pageContentFacade.translate('T').subscribe(c => {
          this.uiNotificationService.success(c.UPDATE_SUCCESS, c.SUCCESS_TITLE);
          this.closeModal();
        });
      });
    }
  }

  private createPageContent() {

    if (!this.pageContentForm.valid || !this.pageContentForm.dirty) {
      this.pageContentFacade.translate('T').subscribe(c => {
        this.uiNotificationService.error(c.CREATE_FAILED, c.FAILED_TITLE);
        this.contents = null;
        this.pageContentForm.markAllAsTouched();
      });
      return;
    }

    const values = this.pageContentForm.value;

    let newPageContentData: any = {};

    for (let field of this.pageContentFields) {
      if (field.partitioning === 'language') {
        for (const language of this.availableLanguages.map(languages => languages.data.code.iv)) {

          newPageContentData = this.dataParser.setData(newPageContentData, field, values[this.getLocalizableFieldName(field.name, language)], language);

        }
      } else {
        newPageContentData = this.dataParser.setData(newPageContentData, field, values[field.name]);
      }
    }

    const ids: string[] = [];
    ids.push(this.id);

    //newPageContentData = this.dataParser.putData(newPageContentData, 'code', guid());
    newPageContentData = this.dataParser.putData(newPageContentData, FieldsName.PAGE_ID, ids);
    newPageContentData = this.dataParser.putData(newPageContentData, FieldsName.ISMODIFIED, true);
    newPageContentData = this.dataParser.putData(newPageContentData, FieldsName.INDEX, 0);

    this.pageContentFacade.createAsPublished(newPageContentData).subscribe(pc => {
      this.pageContents.push(pc);
      this.pageContentFacade.translate('T').subscribe(c => {
        this.uiNotificationService.success(c.UPDATE_SUCCESS, c.SUCCESS_TITLE);
        this.closeModal();
      });
    });

  }

  private getPageContentDescription($event, pageContent: PageContentModel) {
    if ($event) {
      const data: any = {
        title: $event.title,
        isModified: $event.isModified,
        lastModified: $event.lastModified,
        isOpen: $event.isOpen,
        contentType: $event.contentType
      };
      this.pageContentsDescription[pageContent.id] = data;
    }
  }

  openAllSection() {
    const allSectionElement = document.getElementById('panel-all-section');
    if (allSectionElement && allSectionElement.classList.contains('all-section-open')) {
      allSectionElement.classList.remove('all-section-open');
    } else if (allSectionElement) {
      allSectionElement.classList.add('all-section-open');
    }
    this.isAllOpen = !this.isAllOpen;
  }

  private navigateToSection(pageContentId: string) {
    this.isAllOpen = false;
    const desc = this.pageContentsDescription;
    Object.keys(this.pageContentsDescription).forEach(function (key) {
      if (desc) {
        desc[key]['isOpen'] = false;
      }
    });
    this.pageContentsDescription = desc;
    this.pageContentsDescription[pageContentId]['isOpen'] = !this.pageContentsDescription[pageContentId]['isOpen'];
    document.getElementById('manageContent').click();
  }

  pageCapture(pc: Content) {
    let tempPc = cloneDeep(this.relatedContent);
    const fname = tempPc.data.url[this.dataParser.currentLanguageCode];
    const imageName = tempPc.data.pageName.iv;

    this.assetFacade.generateThumbnail(fname, imageName, this.thumbnail).toPromise().then(thumbnail => {
      let data = tempPc.data;

      let assetField: Field = this.pageSchema.fields.find(field => field.name === 'thumbnail');

      if (thumbnail) {
        if (tempPc.data.thumbnail) {
          tempPc.data.thumbnail.iv = [];
        }
        data = this.dataParser.setData(tempPc.data, assetField, thumbnail.id);
        if (pc) {
          this.pageFacade.update(tempPc.id, data).subscribe(retval => {
            this.thumbnail = thumbnail.id
            this.pageContentFacade.translate('T').subscribe(c => {
              this.spinnerService.hide();
              this.uiNotificationService.success(c.UPDATE_SUCCESS, c.SUCCESS_TITLE);
            });
          });
        }
      } else {
        this.pageContentFacade.translate('T').subscribe(c => {
          this.thumbnail = '';
          this.spinnerService.hide();
          this.uiNotificationService.success(c.UPDATE_SUCCESS, c.SUCCESS_TITLE);
        });
      }
    });
  }

  pageContentDrop(event) {
    let pageContentsOrdered: PageContentModel[] = cloneDeep(this.pageContents);

    let temp = pageContentsOrdered[event['previousIndex']];
    pageContentsOrdered[event['previousIndex']] = pageContentsOrdered[event['currentIndex']];
    pageContentsOrdered[event['currentIndex']] = temp;

    this.pageContents = pageContentsOrdered;

    for (let i = 0; i < pageContentsOrdered.length; i++) {
      const pageContentId = pageContentsOrdered[i].id;
      const sub = this.pageContentFacade.get(pageContentId).subscribe(pc => {
        let pcData = cloneDeep(pc.data);
        this.dParser.putData(pcData, 'index', i);
        this.pageContentFacade.update(pageContentId, pcData).subscribe();
        this.subscriptions.push(sub);
      });
    }
  }

  ngAfterViewInit(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  updateFromChild() {
    this.updateRelatedContent(false);
  }

}
